import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js';
import AddChargeAmountUpdateModalUI from './AddChargeAmountUpdateModalUI.js';

class AddChargeAmountUpdateModalSF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			successMsg: null,
			errorList: null,
			// form events
			submitted: false,
			// form field
			invoiceNumber: '',
			invoiceNumberError: null,

			invoiceDateISO: '',
			invoiceDateISOError: null,

			chargeAmountF: '',
			chargeAmountFError: null,

			dueDateISO: '',
			dueDateISOError: null,

			remarks: '',
			remarksError: null,
		};
	}

	render() {
		return (
			<AddChargeAmountUpdateModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				// modes
				addMode={this.props.addMode}
				submitted={this.state.submitted}
				// event handlers
				onSubmit={this.onSubmit}
				onCancelClick={this.props.onCancelClick}
				// form fields
				invoiceNumber={this.state.invoiceNumber}
				onInvoiceNumberChange={(event) => { this.setState({ invoiceNumber: event.target.value }) }}
				invoiceNumberError={this.state.invoiceNumberError}
				setInvoiceNumberError={(error) => { this.setState({ invoiceNumberError: error }) }}
				//
				invoiceDateISO={this.state.invoiceDateISO}
				onInvoiceDateISOChange={(selectedDateISO) => { this.setState({ invoiceDateISO: selectedDateISO }) }}
				invoiceDateISOError={this.state.invoiceDateISOError}
				setInvoiceDateISOError={(error) => { this.setState({ invoiceDateISOError: error }) }}
				//
				chargeAmountF={this.state.chargeAmountF}
				onChargeAmountFChange={(event) => { this.setState({ chargeAmountF: event.target.value }) }}
				chargeAmountFError={this.state.chargeAmountFError}
				setChargeAmountFError={(error) => { this.setState({ chargeAmountFError: error }) }}
				//
				remarks={this.state.remarks}
				onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
				remarksError={this.state.remarksError}
				setRemarksError={(error) => { this.setState({ remarksError: error }) }}
				//
				dueDateISO={this.state.dueDateISO}
				onDueDateISOChange={(selectedDateISO) => { this.setState({ dueDateISO: selectedDateISO }) }}
				dueDateISOError={this.state.dueDateISOError}
				setDueDateISOError={(error) => { this.setState({ dueDateISOError: error }) }}
				//
				alreadyPaid={this.props.alreadyPaid}
			/>
		);
	}

	componentDidMount() {
		let context = this.props.context;
		Modal.setAppElement('body');
	}

	componentDidUpdate(prevProps) {
		const charge = this.props.selectedCharge;
		if (charge) {
			console.log('selectedCharge:', charge.dateCreated);
		}
		// Only update state if the charge has changed (by dateCreated or reference)
		const prevCharge = prevProps.selectedCharge;

		// If no charge, do nothing
		if (!charge) return;

		// If previous charge exists and is the same as current (by dateCreated), do nothing
		if (
			prevCharge &&
			charge &&
			prevCharge.dateCreated === charge.dateCreated &&
			prevCharge.invoiceNumber === charge.invoiceNumber &&
			prevCharge.amount === charge.amount &&
			prevCharge.dueDateISO === charge.dueDateISO &&
			prevCharge.remarks === charge.remarks
		) {
			return;
		}

		// Only update state if the values are actually different
		const { invoiceNumber, invoiceDateISO, amount, dueDateISO, remarks } = charge;
		if (
			this.state.invoiceNumber !== invoiceNumber ||
			this.state.invoiceDateISO !== invoiceDateISO ||
			this.state.chargeAmountF !== amount ||
			this.state.dueDateISO !== dueDateISO ||
			this.state.remarks !== remarks
		) {
			this.setState({
				invoiceNumber: invoiceNumber,
				invoiceDateISO: invoiceDateISO,
				chargeAmountF: amount ? amount / 100 : '',
				dueDateISO: dueDateISO,
				remarks: remarks,
			});
		}
	}

	onSubmit = () => {
		let invoiceIdOrNumber = this.props.invoiceNumber
		if (!invoiceIdOrNumber || invoiceIdOrNumber === '') {
			invoiceIdOrNumber = "NA"
		}

		let dateCreated = this.props.dateCreated
		if (!dateCreated || dateCreated === '') {
			dateCreated = "NA"
		}

		let submitted = this.state.submitted
		if (submitted)
			return

		console.log('calling server')
		this.setState({ submitted: true })

		RestApiUtils.put(this.props.context,
			`/api/su/loans/${this.props.loan.loanId}/charges/${invoiceIdOrNumber}/oope/${dateCreated}/update`,
			this.onSubmitCallback, {
			invoiceNumber: this.state.invoiceNumber,
			invoiceDateISO: this.state.invoiceDateISO,
			chargeAmountF: this.state.chargeAmountF,
			remarks: this.state.remarks,
			dueDateISO: this.state.dueDateISO
		}
		)
	}

	onSubmitCallback = (response) => {
		let errorList = []
		response.errorList.forEach(error => {
			errorList.push(error.message)
		})

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		})

		if (response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					successMsg: null
				})
				this.props.onCancelClick()
				this.props.onRefreshClick('noBusy')
			}, 2000)
		}
	}
}

export default AddChargeAmountUpdateModalSF;
